import {
  GeocodingPlaceTypeSchema,
  type GeocodingPlaceType as GeneratedGeocodingPlaceType
} from '~/services/api/generated'

// Mirrors backend App\Enums\GeocodingPlaceType

export type GeocodingPlaceType = GeneratedGeocodingPlaceType

export const GeocodingPlaceType = {
  ADDRESS: GeocodingPlaceTypeSchema.enum.address,
  REGION: GeocodingPlaceTypeSchema.enum.region,
  PLACE: GeocodingPlaceTypeSchema.enum.place,
  NEIGHBORHOOD: GeocodingPlaceTypeSchema.enum.neighborhood,
  POI: GeocodingPlaceTypeSchema.enum.poi,
  POSTCODE: GeocodingPlaceTypeSchema.enum.postcode
} satisfies Record<string, GeneratedGeocodingPlaceType>

export const GeocodingPlaceTypeValues: readonly GeneratedGeocodingPlaceType[] = [
  GeocodingPlaceTypeSchema.enum.address,
  GeocodingPlaceTypeSchema.enum.region,
  GeocodingPlaceTypeSchema.enum.place,
  GeocodingPlaceTypeSchema.enum.neighborhood,
  GeocodingPlaceTypeSchema.enum.poi,
  GeocodingPlaceTypeSchema.enum.postcode
]
